var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrophoneWithGradient = function SvgMicrophoneWithGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    className: "svgr-icon"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "microphone-with-gradient_svg__a",
    x1: 0,
    x2: 24,
    y1: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5CF6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#microphone-with-gradient_svg__a)",
    d: "M12 14.92c-.81 0-1.5-.29-2.07-.85A2.8 2.8 0 0 1 9.08 12V6.17c0-.81.29-1.5.85-2.07A2.8 2.8 0 0 1 12 3.25c.81 0 1.5.28 2.07.85.56.57.85 1.26.85 2.07V12c0 .81-.29 1.5-.85 2.07-.57.56-1.26.85-2.07.85m-.87 5.83v-2.4a6.18 6.18 0 0 1-3.98-2.12A6.22 6.22 0 0 1 5.58 12h1.75c0 1.3.46 2.4 1.37 3.3a4.5 4.5 0 0 0 3.3 1.37c1.3 0 2.4-.46 3.3-1.37a4.5 4.5 0 0 0 1.37-3.3h1.75c0 1.62-.53 3.03-1.57 4.23a6.18 6.18 0 0 1-3.97 2.11v2.41zm.87-7.58c.33 0 .6-.12.83-.34.22-.22.34-.5.34-.83V6.17c0-.33-.12-.61-.34-.83-.22-.23-.5-.34-.83-.34s-.6.11-.83.34c-.22.22-.34.5-.34.83V12c0 .33.12.6.34.83.22.22.5.34.83.34"
  })));
};
export default SvgMicrophoneWithGradient;